export const COLORING_IMAGE_URL =
  'https://cdn.lemanapro.ru/lmru/image/upload/site/poh6NeiSfUOVDz_1nh0GWw/services-platform-kolerovka-new-icon.svg';

export const COLORING_IMAGE_WIDTH = '50';

export const COLORING_IMAGE_HEIGHT = '50';
